// react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// third-party
import classNames from 'classnames';
import PropTypes from 'prop-types';

// application
import SlickWithPreventSwipeClick from './SlickWithPreventSwipeClick';

const slickSettingsFeatured = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 400,
};
const slickSettingsThumbnails = {
    columnar: {
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 3 } },
            { breakpoint: 767, settings: { slidesToShow: 5 } },
            { breakpoint: 479, settings: { slidesToShow: 4 } },
            { breakpoint: 379, settings: { slidesToShow: 3 } },
        ],
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 400,
    },
    quickview: {
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 4 } },
            { breakpoint: 767, settings: { slidesToShow: 5 } },
            { breakpoint: 479, settings: { slidesToShow: 4 } },
            { breakpoint: 379, settings: { slidesToShow: 3 } },
        ],
        slidesToScroll: 1,
        slidesToShow: 5,
        speed: 400,
    },
    sidebar: {
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 3 } },
            { breakpoint: 767, settings: { slidesToShow: 5 } },
            { breakpoint: 479, settings: { slidesToShow: 4 } },
            { breakpoint: 379, settings: { slidesToShow: 3 } },
        ],
        slidesToScroll: 1,
        slidesToShow: 4,
        speed: 400,
    },
    standard: {
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            { breakpoint: 1199, settings: { slidesToShow: 4 } },
            { breakpoint: 991, settings: { slidesToShow: 3 } },
            { breakpoint: 767, settings: { slidesToShow: 5 } },
            { breakpoint: 479, settings: { slidesToShow: 4 } },
            { breakpoint: 379, settings: { slidesToShow: 3 } },
        ],
        slidesToScroll: 1,
        slidesToShow: 5,
        speed: 400,
    },
};

class ProductGallery extends Component {
    gallery;

    /** @var {Promise} */
    createGallery = null;

    imagesRefs = [];

    unmounted = false;

    constructor(props) {
        super(props);

        this.state = {
            currentIndex: 0,
            transition: false,
        };
    }

    componentDidMount() {
        this.createGallery = import('../../photoswipe').then((module) => module.createGallery);
    }

    componentWillUnmount() {
        if (this.gallery) {
            this.gallery.destroy();
        }

        this.unmounted = true;
    }

    handleFeaturedClick = (event, index) => {
        if (!this.createGallery) {
            return;
        }

        event.preventDefault();

        const { images } = this.props;
        const items = images.map((image) => ({
            h: 700,
            msrc: image,
            src: image,
            w: 700,
        }));

        const options = {
            bgOpacity: 0.9,
            getThumbBoundsFn: (index) => {
                if (!this.imagesRefs[index]) {
                    return null;
                }

                const imageElement = this.imagesRefs[index];
                const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                const rect = imageElement.getBoundingClientRect();

                return {
                    w: rect.width,
                    x: rect.left,
                    y: rect.top + pageYScroll,
                };
            },
            history: false,
            index,
        };

        this.createGallery.then((createGallery) => {
            if (this.unmounted) {
                return;
            }

            this.gallery = createGallery(items, options);

            this.gallery.listen('beforeChange', () => {
                if (this.gallery && this.slickFeaturedRef) {
                    this.slickFeaturedRef.slickGoTo(this.gallery.getCurrentIndex(), true);
                }
            });
            this.gallery.listen('destroy', () => {
                this.gallery = null;
            });

            this.gallery.init();
        });
    };

    handleThumbnailClick = (index) => {
        const { transition } = this.state;

        if (transition) {
            return;
        }

        this.setState(() => ({ currentIndex: index }));

        if (this.slickFeaturedRef) {
            this.slickFeaturedRef.slickGoTo(index);
        }
    };

    handleFeaturedBeforeChange = (oldIndex, newIndex) => {
        this.setState(() => ({
            currentIndex: newIndex,
            transition: true,
        }));
    };

    handleFeaturedAfterChange = (index) => {
        this.setState(() => ({
            currentIndex: index,
            transition: false,
        }));
    };

    setSlickFeaturedRef = (ref) => {
        this.slickFeaturedRef = ref;
    };

    render() {
        const { images, layout } = this.props;
        const { currentIndex } = this.state;

        const featured = images.map((image, index) => (
            <Link
                key={index}
                to={`/${image}`}
                onClick={(event) => this.handleFeaturedClick(event, index)}
                target="_blank"
            >
                <img
                    src={image}
                    alt=""
                    ref={(element) => {
                        this.imagesRefs[index] = element;
                    }}
                    style={{ width: '100%' }}
                />
            </Link>
        ));

        const thumbnails = images.map((image, index) => {
            const classes = classNames('product-gallery__carousel-item', {
                'product-gallery__carousel-item--active': index === currentIndex,
            });

            return (
                <button type="button" key={index} onClick={() => this.handleThumbnailClick(index)} className={classes}>
                    <img className="product-gallery__carousel-image" src={image} alt="" />
                </button>
            );
        });

        return (
            <div className="product__gallery">
                <div className="product-gallery">
                    <div className="product-gallery__featured">
                        <SlickWithPreventSwipeClick
                            ref={this.setSlickFeaturedRef}
                            {...slickSettingsFeatured}
                            beforeChange={this.handleFeaturedBeforeChange}
                            afterChange={this.handleFeaturedAfterChange}
                        >
                            {featured}
                        </SlickWithPreventSwipeClick>
                    </div>
                    <div className="product-gallery__carousel">
                        <SlickWithPreventSwipeClick {...slickSettingsThumbnails[layout]}>
                            {thumbnails}
                        </SlickWithPreventSwipeClick>
                    </div>
                </div>
            </div>
        );
    }
}

ProductGallery.propTypes = {
    images: PropTypes.array,
    layout: PropTypes.oneOf(['standard', 'sidebar', 'columnar', 'quickview']),
};

ProductGallery.defaultProps = {
    images: [],
    layout: 'standard',
};

export default ProductGallery;
